import { Component, ElementRef, ViewChild, QueryList, ViewChildren, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FerrerAuthService } from 'app/services/authentication.service';
import { FormsModule } from '@angular/forms';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { NavigationFlowService } from 'app/services/navigation-flow.service';

@Component({
  selector: 'app-otpchangePassword-dialog',
  templateUrl: './otpchangepwd-dialog.component.html',
  styleUrls: ['./otpchangepwd-dialog.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    TranslocoPipe,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
})
export class OtpChangePasswordDialogComponent {
  buttonDisabled: boolean = true;
  registrationForm: FormGroup;
  apiResponse: any;
  email: string;
  isLoading = false;
  apierror: string | null = null;
  constructor(
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private ferrerAuth: FerrerAuthService,
    private translocoService: TranslocoService,
    private dialogUtilsService: DialogUtilsService,
    private navigationFlow: NavigationFlowService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.apiResponse = this.data.apiResponse;
      this.email = this.data.email;
    }
    this.registrationForm = this.fb.group({
      password: ['', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(16)
      ]]
    });
  }
  cambiarContrasenya() {
    if (this.registrationForm.invalid) {
      this.registrationForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const password = this.registrationForm.get('password')?.value;
    this.ferrerAuth.rememberPassword(this.email, password).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.openLoginDialog();

      },
      error: (error) => {
        console.error('Failed to send OTP code:', error);
        // We don't show errors to user in fire-and-forget scenarios
        this.handleApiError(error);
      }
    });
  }

  handleApiError(error: any): void {

    // Get error response body
    const errorBody = error.error.message || error.error || error;
    this.apierror = errorBody;
  }
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  openLoginDialog(): void {
    // Close any existing dialog
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this.dialogRef = this.dialog.open(LoginDialogComponent, {
      width: `${width}px`,
      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',

    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this.dialogRef);

    this.dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this.dialogRef = null;
    });
  }
  close(): void {
    const isInIframe = this.isRunningInIframe();
    if (isInIframe) {
      // We're in an iframe, post message to parent
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'loginSuccess',
          userData: {
            email: this.email
          }
        }, '*');
      }
    } else {
      this.dialogRef.close();

      window.location.href = this.apiResponse?.returnUrl;

    }
    this.dialogRef.close();
  }

  /**
   * Method for X button close - different from Continue button
   * v2.0: Closes and opens login dialog
   * v1.5: Navigates to returnUrl
   */
  closeDialog(): void {
    console.log('[OTP-CHANGEPWD] Close button (X) clicked');

    this.dialogUtilsService.closeDialog(
      this.dialogRef,
      undefined,
      {
        dialogType: 'otp-changepwd',
        navigationFlow: this.navigationFlow
      }
    );
  }

  shouldShowCloseButton(): boolean {
    return this.dialogUtilsService.shouldShowCloseButton();
  }

  private isRunningInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we get a security error, we're definitely in an iframe
      return true;
    }
  }
}
